export default "/img/SZ.9cc0aee6f4e4451cdf30de4604adbdb7.png";